import { BeltSyllabus } from './types';

export const blackBelt: BeltSyllabus = {
    id: 'black-1st',
    name: '1st Degree Black Belt',
    color: '#000000',
    theoryUnder13: [],
    theoryOver13: [
        {
            title: 'Theory',
            subTitle: 'Those going for 2nd degree should learn everything for previous degrees plus',
            items: [
                {
                    question: 'Endeavour to learn any additional stances/techniques, also the terminology for all the new movements in the 2nd degree patterns, as well as their applications',
                    answer: ' '
                },
                { question: 'Training Secret', answer: ' ' },
                { question: 'Theory of Power', answer: ' ' },
                { question: 'Vital Spots', answer: ' ' }
            ]
        },
        {
            title: 'Theory Resources',
            items: [
                { question: 'The Vision TKD Association Black Book or AETA White Book', answer: ' ' },
                { question: 'Path to Black Belt', answer: ' ' },
                { question: 'Condensed Encyclopaedia 1999 version', answer: ' ' },
                { question: 'ITF International Taekwon-Do Federation', answer: 'https://itftkd.sport/' },
                { question: 'ITF England', answer: 'https://www.itfengland.com/' }
            ]
        }
    ],
    practical: [
        {
            title: 'Kicking Combinations (9%)',
            items: [
                { question: 'Front leg Hooking Kick, Middle Side Piercing Kick (consecutive), Reverse Turning Kick (180 spin)', answer: ' ' },
                { question: 'Front leg Outward Vertical Kick, Front Kick (consecutive), rear leg Jump Back Kick', answer: ' ' },
                { question: 'Rear leg Turning Kick, Flying Side Kick (twin foot take off)', answer: ' ' },
                { question: 'Rear leg Low Twisting Kick (hold), rear leg Jump Reverse Turning Kick (360 spin)', answer: ' ' },
                { question: 'Rear leg Downward Kick, front leg 360 Flying Back Kick', answer: ' ' },
                { question: 'Front leg Side Checking Kick, Side Piercing Kick (consecutive), Rear leg Slow Reverse Hooking Kick', answer: ' ' }
            ]
        },
        {
            title: 'Patterns (35%)',
            subTitle: 'Chon-Ji to Ge-Baek',
            items: [
                { question: 'Chon-Ji', answer: '2%' },
                { question: 'Dan-Gun', answer: '2%' },
                { question: 'Do-San', answer: '2%' },
                { question: 'Won-Hyo', answer: '2%' },
                { question: 'Yul-Gok', answer: '2%' },
                { question: 'Joong-Gun', answer: '3%' },
                { question: 'Toi-Gye', answer: '3%' },
                { question: 'Hwa-Rang', answer: '3%' },
                { question: 'Choong-Moo', answer: '4%' },
                { question: 'Kwang-Gae', answer: '4%' },
                { question: 'Po-Eun', answer: '4%' },
                { question: 'Ge-Baek', answer: '4%' }
            ]
        },
        {
            title: 'Self-Defence (12%)',
            subTitle: 'With mouth guards & groin guards',
            items: [
                { question: 'Push Against Shoulder - single or two hands', answer: ' ' },
                { question: 'Front & Rear Single & Twin Lapel Grabs', answer: ' ' },
                { question: 'Front & Rear Choke Holds', answer: ' ' },
                { question: 'Front & Rear Guillotine', answer: ' ' },
                { question: 'Swinging Punch to the Head', answer: ' ' },
                { question: 'Front Kick & Turning Kick - waist level and below', answer: ' ' }
            ]
        },
        {
            title: 'Sparring (17%)',
            items: [
                { question: '3 Step Sparring', answer: ' ' },
                { question: '2 Step Sparring', answer: ' ' },
                { question: '1 Step Sparring', answer: ' ' },
                { question: '1 Step Foot Sparring', answer: ' ' },
                { question: 'Competition Sparring', answer: ' ' },
                { question: '2 V 1 Sparring', answer: ' ' }
            ]
        },
        {
            title: 'Special Technique (6%)',
            subTitle: [
                'Candidate chooses the height',
                'Performed on Spec Tech Holder',
                '3 Attempts'
            ],
            items: [
                { question: 'Jump Reverse Turning Kick', answer: ' ' },
                { question: '360 Back Kick', answer: ' ' }
            ]
        },
        {
            title: 'Special Technique (3%)',
            subTitle: [
                'Choose 1 out of 4 Techniques',
                'Performed on Targets',
                '3 Attempts',
                'Demonstrate Power, Accuracy, Agility'
            ],
            items: [
                { question: 'Two Directional Kick', answer: ' ' },
                { question: 'Side Kick, Back Kick (Spiral)', answer: ' ' },
                { question: 'Side Kick, Turning Kick', answer: ' ' },
                { question: 'Twin Front Kick (Angled Targets)', answer: ' ' }
            ]
        },
        {
            title: 'Power Test (6%)',
            subTitle: [
                'Minimum 1 White Board for 16yrs+',
                'Minimum 1 Cream Board for Females/15yrs-',
                'Select more boards to receive a higher %',
                '3 Attempts'
            ],
            headerBackgroundColor: '#d6eaf8',
            items: [
                { question: 'Twisting Kick (90 degree angle)', answer: ' ' },
                { question: 'Jumping Side Kick from a Parallel Stance (one and a half shoulder width away from the holder)', answer: ' ' }
            ]
        },
        {
            title: 'Power Test - Hand (6%)',
            subTitle: [
                'Choose 1 out of 3 Techniques',
                'Minimum 2 White Boards for 16yrs+',
                'Minimum 1 White/Cream Board for Female/15yrs-',
                'Select more boards to receive a higher %',
                '3 Attempts'
            ],
            headerBackgroundColor: '#d6eaf8',
            items: [
                { question: 'Punch', answer: ' ' },
                { question: 'Knifehand', answer: ' ' },
                { question: 'Reverse Knifehand', answer: ' ' }
            ]
        },
        {
            title: 'Power Test - Foot (6%)',
            subTitle: [
                'Choose 1 out of 3 Techniques',
                'Minimum 2 White Boards for 16yrs+',
                'Minimum 1 White Board or 2 Cream Boards for Female/15yrs-',
                'Select more boards for a higher %',
                '3 Attempts'
            ],
            headerBackgroundColor: '#d6eaf8',
            items: [
                { question: 'Turning Kick', answer: ' ' },
                { question: 'Reverse Turning Kick', answer: ' ' },
                { question: 'Back Kick', answer: ' ' }
            ]
        },
        {
            title: 'Theory',
            items: [
                { question: 'Theory Paper - must get 60% before the practical exam', answer: ' ' }
            ]
        }
    ]
};
